<template lang="html">
  <form tabindex="0" class="keyword-filter" v-on:submit.prevent.stop="onEnter()"
    @keydown.enter.prevent.stop="onEnter()">
    <label class="keyword-filter__wrapper">
      <!-- the input field -->
      <input type="text" ref="search" class="keyword-filter__input" placeholder="" autocomplete="off"
        v-model.trim="query" @input="onSubmit" name="keywordFilter" @keydown.enter.prevent.stop=""
        @keyup.enter.prevent.stop="" />
    </label>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';
import _debounce from 'lodash/debounce';

export default {
  props: ['lookup', 'limit', 'pathOptions'],
  data() {
    return {
      query: '',
      hasSubmitted: false,
      lastQuery: '',
    };
  },
  watch: {
    limit: 'onSubmit',
  },
  computed: mapGetters({
    user: 'user/user/user',
    shortSearch: 'landlord/parkings/shortSearch',
  }),
  mounted() {
    this.onRedirect();
    if (!navigator.userAgent.match(/Mobi/)) {
      this.$refs.search.focus();
    }
  },
  methods: {
    onSubmit: _debounce(function () {
      if (this.query.length < 3 && this.query.length > 0 && !this.shortSearch) {
        return;
      }

      this.$emit('search', {
        query: this.query,
      });

      if (this.query
        && this.pathOptions.dateFrom
        && this.pathOptions.dateTo) {
        this.$router.push({
          query: {
            keyword: this.query,
            searchByPlate: this.pathOptions.searchByPlate,
            dateFrom: this.pathOptions.dateFrom,
            dateTo: this.pathOptions.dateTo,
          }
        });
      } else if (this.query) {
        this.$router.push({
          query: {
            keyword: this.query,
            searchByPlate: this.pathOptions.searchByPlate,
          }
        });
      } else if (this.pathOptions.dateFrom && this.pathOptions.dateTo) {
        this.$router.push({
          query: {
            searchByPlate: this.pathOptions.searchByPlate,
            dateFrom: this.pathOptions.dateFrom,
            dateTo: this.pathOptions.dateTo,
          }
        });
      } else if (this.pathOptions) {
        this.$router.push({
          query: {
            searchByPlate: this.pathOptions.searchByPlate,
          }
        });
      } else {
        this.$router.push({ query: {} });
      }

      if (!this.hasSubmitted) {
        this.hasSubmitted = true;
        this.lastQuery = this.query;
        this.$store.dispatch(`landlord/${this.lookup}`, {
          keyword: this.query,
          user: this.user,
          searchByPlate: this.pathOptions.searchByPlate,
          dateFrom: this.pathOptions.dateFrom,
          dateTo: this.pathOptions.dateTo,
        }).then(() => {
          this.hasSubmitted = false;
          if (this.lastQuery !== this.query) {
            this.onSubmit();
          }
        }).catch(() => {
          this.hasSubmitted = false;
          if (this.lastQuery !== this.query) {
            this.onSubmit();
          }
        });
      }
    }, 600),
    onEnter() {
      this.$router.push({ path: this.lookup, query: { keyword: this.query } });
    },
    onRedirect() {
      if (this.$route.query.keyword) {
        this.query = this.$route.query.keyword;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';
@import '~styles/_mixins.scss';

.test {
  display: flex;
  flex-direction: row;
}

.keyword-filter {
  display: inline-block;
  max-width: 470px;
  width: calc(100% - 116.5px);
  background-color: var(--white);
  position: relative;
  transition: all 225ms ease-in-out;
  @include shadow(1);

  @media screen and (max-width: 759px) {
    width: 100%;
    max-width: none;
  }

  @media screen and (max-width: 715px) {
    flex: 1;
    display: flex;
  }

  &:focus,
  &:hover,
  &_active {
    transition: all 225ms ease-in-out;
  }

  &.inline-search {
    @include shadow(2);
    background-color: var(--white);
  }

  &_active,
  &.inline-search {

    .keyword-filter__wrapper {
      border-bottom: 1px solid var(--grey-five);
      margin-bottom: 0;
    }
  }

  &__wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 10px 0 10px;
    margin-bottom: 1px;

    @media screen and (max-width: 715px) {
      padding: 0 20px 0 0;
    }

    &:after {
      content: '';
      display: inline-block;
      width: 44px;
      height: 36px;
      background: url('~icons/search.svg') 50% 50% no-repeat;
    }
  }

  &__input {
    font-size: 24px;
    height: 60px;
    border: none;
    width: 100%;
    letter-spacing: 1px;
    margin-right: 20px;

    @media screen and (max-width: 715px) {
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parkings/KeywordFilter.vue